import { render, staticRenderFns } from "./ArticlesFeed.vue?vue&type=template&id=409fdcbd&lang=pug&"
import script from "./ArticlesFeed.vue?vue&type=script&lang=js&"
export * from "./ArticlesFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports